import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const FolderOrganizer = ({ folders, selectedFolder, onFolderSelect, onCreateFolder, onRenameFolder, onDeleteFolder }) => {
  const [isCreating, setIsCreating] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [editingFolder, setEditingFolder] = useState(null);
  const [editName, setEditName] = useState('');

  const handleCreateFolder = () => {
    if (newFolderName?.trim()) {
      onCreateFolder(newFolderName?.trim());
      setNewFolderName('');
      setIsCreating(false);
    }
  };

  const handleRenameFolder = (folderId) => {
    if (editName?.trim()) {
      onRenameFolder(folderId, editName?.trim());
      setEditingFolder(null);
      setEditName('');
    }
  };

  const startEdit = (folder) => {
    setEditingFolder(folder?.id);
    setEditName(folder?.name);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Folders</h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="Plus"
          iconPosition="left"
          onClick={() => setIsCreating(true)}
        >
          New
        </Button>
      </div>
      <div className="space-y-2">
        {/* All Prompts */}
        <button
          onClick={() => onFolderSelect(null)}
          className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
            selectedFolder === null ? 'bg-primary/10 text-primary' : 'hover:bg-muted text-foreground'
          }`}
        >
          <Icon name="Inbox" size={18} />
          <span className="text-sm font-medium flex-1 text-left">All Prompts</span>
          <span className="text-xs text-muted-foreground">138</span>
        </button>

        {/* Favorites */}
        <button
          onClick={() => onFolderSelect('favorites')}
          className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
            selectedFolder === 'favorites' ? 'bg-primary/10 text-primary' : 'hover:bg-muted text-foreground'
          }`}
        >
          <Icon name="Star" size={18} />
          <span className="text-sm font-medium flex-1 text-left">Favorites</span>
          <span className="text-xs text-muted-foreground">42</span>
        </button>

        <div className="h-px bg-border my-2"></div>

        {/* Custom Folders */}
        {folders?.map((folder) => (
          <div key={folder?.id}>
            {editingFolder === folder?.id ? (
              <div className="flex items-center gap-2 px-3 py-2">
                <Input
                  type="text"
                  value={editName}
                  onChange={(e) => setEditName(e?.target?.value)}
                  onKeyDown={(e) => {
                    if (e?.key === 'Enter') handleRenameFolder(folder?.id);
                    if (e?.key === 'Escape') setEditingFolder(null);
                  }}
                  className="flex-1"
                />
                <button
                  onClick={() => handleRenameFolder(folder?.id)}
                  className="text-success hover:text-success/80"
                >
                  <Icon name="Check" size={16} />
                </button>
                <button
                  onClick={() => setEditingFolder(null)}
                  className="text-error hover:text-error/80"
                >
                  <Icon name="X" size={16} />
                </button>
              </div>
            ) : (
              <div className="group flex items-center gap-2">
                <button
                  onClick={() => onFolderSelect(folder?.id)}
                  className={`flex-1 flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
                    selectedFolder === folder?.id ? 'bg-primary/10 text-primary' : 'hover:bg-muted text-foreground'
                  }`}
                >
                  <Icon name="Folder" size={18} />
                  <span className="text-sm font-medium flex-1 text-left">{folder?.name}</span>
                  <span className="text-xs text-muted-foreground">{folder?.count}</span>
                </button>
                <div className="hidden group-hover:flex items-center gap-1">
                  <button
                    onClick={() => startEdit(folder)}
                    className="p-1 hover:bg-muted rounded transition-colors"
                    title="Rename"
                  >
                    <Icon name="Edit2" size={14} className="text-muted-foreground" />
                  </button>
                  <button
                    onClick={() => onDeleteFolder(folder?.id)}
                    className="p-1 hover:bg-muted rounded transition-colors"
                    title="Delete"
                  >
                    <Icon name="Trash2" size={14} className="text-muted-foreground" />
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}

        {/* Create New Folder */}
        {isCreating && (
          <div className="flex items-center gap-2 px-3 py-2">
            <Input
              type="text"
              placeholder="Folder name"
              value={newFolderName}
              onChange={(e) => setNewFolderName(e?.target?.value)}
              onKeyDown={(e) => {
                if (e?.key === 'Enter') handleCreateFolder();
                if (e?.key === 'Escape') setIsCreating(false);
              }}
              className="flex-1"
            />
            <button
              onClick={handleCreateFolder}
              className="text-success hover:text-success/80"
            >
              <Icon name="Check" size={16} />
            </button>
            <button
              onClick={() => setIsCreating(false)}
              className="text-error hover:text-error/80"
            >
              <Icon name="X" size={16} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FolderOrganizer;